<template>
    <Layout
        :header="{ text: '保單借款', backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME } }, }">
        <div class="pt-2 pb-6">
            <Process :steps="['同意條款', '選擇保單', '確認資料', '手機驗證',]" :index="1"></Process>
        </div>
        <div class="pb-8">
            <h2 class="font-bold text-2xl pb-4">填寫優惠利率申請金額</h2>
            <div class="pb-4">
                <p>同一要保人申請的上限為新台幣 10 萬元</p>
            </div>
            <OptionBoxList :options="policyOptions" />
        </div>
        <ul class="list-disc pl-6 text-sm">
            <li class="pb-2">單張保險契約單次借款之金額，最低限制為約當新臺幣1,000元。</li>
            <li class="pb-2">辦理保單借款時，若該保單尚有未清償之借款本息者，本次欲借款金額加已借款本息合計須於該保單最高可借款金額範圍內。</li>
            <li class="pb-2">保單已為繳清件、展期件、自動墊繳件、以支票還款且尚未兌現者，請洽本公司各地服務櫃檯，或由您的保單服務人員協助以書面方式辦理。</li>
            <li class="pb-2">保單因變更中、保單借/還款中或理賠申請中，暫時無法申請保單借款時，請通知您的服務人員協助辦理，或洽詢保單借還款服務專線0809-026-688。</li>
            <li class="pb-2">
                本公司不定期推出保單借款優惠專案，若您辦理保單借款當時符合專案條件，即可享有優惠，保單借款優惠專案詳情請查詢本公司官方網站www.fubon.com，或保單借還款服務專線0809-026-688。</li>
            <li class="pb-2">您的保險單、存摺、印章、網路交易帳號密碼應親自保管，請勿交予他人，本公司嚴禁業務同仁代保管客戶保險單、存摺、印章、網路交易帳號密碼等資料。</li>
        </ul>
        <div class="h-[200px]"></div>
        <template #fixedBottom>
            <div class="bg-white">
                <div class="max-w-[768px] mx-auto px-5 py-3">
                    <div>
                        選擇 <span class="text-[#00A59B]">{{ policyOptions.inputValue.length || '--' }}</span> 張保單
                    </div>
                    <div class="flex justify-between">
                        <div class="">總借款金額 (新台幣)</div>
                        <div class="">{{ moneyTotal || '--' }}</div>
                    </div>
                </div>
            </div>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="!isAllowNext" @click="goNextPage">下一步</button>
        </template>
        <Loading :is-loading="isLoading" />
    </Layout>
</template>
<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref, computed, watch, reactive } from 'vue';
import routeName from '@/router/constant.js';
import Layout from '@/components/cloudCounter/Layout.vue';
import Process from '@/components/cloudCounter/Process.vue';
import OptionBoxList from '@/components/cloudCounter/OptionBoxList.vue';
import Loading from '@/components/Loading.vue';
import { useRouter, } from 'vue-router';

const router = useRouter();
const moneyTotal = ref('');
const isLoading = ref(false);
//選擇保單
const policyOptions = reactive({
    inputValue: [],
    inputType: 'checkbox',
    inputName: 'policy',
    inputOptions: [{
        title: 'XWS5 富邦人壽新平準終身壽險',
        subTitle: '1068302189-00',
        list: [
            { key: '被保險人', value: '林小邦', },
            { key: '本月利率 (年利率)', value: '5.75%', },
            { key: '本次借款金額', value: '145,000', },
        ],
        optionValue: '1068302189-00',
        textInputList: [{
            name: '欲借款金額',
            value: '',
            placeholder: '請輸入借款金額',
            type: 'number',
            max: 99000,
            min: 1000,
            minErrorText: '最低借款金額為 新台幣1,000 元',
            maxErrorText: '可借款金額上限為 新台幣99,000 元',
        }],
    },
    {
        title: 'XWS5 富邦人壽新平準終身壽險22',
        subTitle: '1068302189-22',
        list: [
            { key: '被保險人', value: '林小邦', },
            { key: '本月利率 (年利率)', value: '5.75%', },
            { key: '本次借款金額', value: '145,000', },
        ],
        optionValue: '1068302189-22',
        textInputList: [{
            name: '欲借款金額',
            value: '',
            placeholder: '請輸入借款金額',
            type: 'number',
            max: 99000,
            min: 1000,
            minErrorText: '最低借款金額為 新台幣1,000 元',
            maxErrorText: '可借款金額上限為 新台幣99,000 元',
        }],
    },],
});

const isAllowNext = computed(() => {
    return Number(moneyTotal.value.replace(',', '')) <= 100000 && checkInputMoney(policyOptions)
})

watch(() => policyOptions, (_val) => {
    let sum = 0;
    const _inputOptions = policyOptions.inputOptions;
    if (_inputOptions.length >= 1) {
        if (_inputOptions.length == 1) {
            sum = parseInt(_inputOptions[0].textInputList[0].value) || 0;
        } else {
            for (let i = 0; i < _inputOptions.length; i++) {
                const element = _inputOptions[i];
                if (policyOptions.inputValue.includes(element.optionValue)) {
                    sum += (parseInt(element.textInputList[0].value) || 0);
                }
            }
        }
    }
    moneyTotal.value = thousandthsFormat(sum);
}, { deep: true });

const thousandthsFormat = (value) => {
    const regex = /\B(?=(\d{3})+(?!\d))/g
    value = value.toString()
    return value.replace(regex, ',')
}

// 找出目前有選取的保單，並確認是否為0或大於最大、小於1000元
const checkInputMoney = (opt) => {
    return !opt.inputOptions.filter(el => opt.inputValue.includes(el.optionValue)).some(el => Number(el.textInputList[0]?.value) === 0 || el.textInputList[0]?.value > el.textInputList[0]?.max || el.textInputList[0]?.value < 1000)
}

const goNextPage = () => {
    router.push({ name: '' });
};
</script>
<style lang="scss" scoped></style>